import { Injectable, Inject } from '@angular/core';
import { AbstractControl, ValidatorFn, Validators, FormGroup } from '@angular/forms';
import { CustomError, LoggedUserViewModel, TcPerfilUsuarioEnum } from '../types/common';
import { NotificationService } from './services/notification.service';
import { ExceptionManager } from './handlers/exceptionManager';
import { AuthService } from './services/auth.service';

import config from '../config';
import { HttpResponse } from '@angular/common/http';
import { ConfigurationService } from './services/configuration.service';
import { BehaviorSubject } from 'rxjs';
import { UserDataViewModel } from '../../../_campanias/buscadores/solicitudes/buscador-solicitud-cam.types';

@Injectable()
export class ComponentBase {
    submitted = false;
    loading = false;
    searchingButton = false;
    form: FormGroup;
    loggedInUser: LoggedUserViewModel | null;
    es: any;
    MegaSizeLimitsCargado$ = new BehaviorSubject(false);
    sizeLimitDefault: number;
    userData: UserDataViewModel;

    constructor(
        @Inject(AuthService) protected authService: AuthService | null = null,
        @Inject(NotificationService)
        protected notificationService: NotificationService | null = null,
        @Inject(NotificationService)
        protected exceptionManager: ExceptionManager | null = null,
        @Inject(ConfigurationService)
        protected configService?: ConfigurationService,
    ) {
        if (this.authService) {
            this.loggedInUser = this.authService.getLoggedInUser();
            if (this.loggedInUser) {
                this.getUserData();
            }
        }
        if (configService && configService.limitsDocSize == null) {
            configService.getMegaSizeLimit().subscribe(res => {
                configService.limitsDocSize = res;
                this.MegaSizeLimitsCargado$.next(true);
            });
        }
    }

    GetParamDate(value: Date) {
        //return value.toLocaleString("es-ES");
        return value.toDateString();
    }

    public getValorSizeLimit(key: string) {
        let sizeLimit;
        let config = this.getConfig();
        this.sizeLimitDefault = parseInt(config.SizeLimitDefault);
        sizeLimit = this.configService?.limitsDocSize?.Limits?.find(t => t.Component === key)?.SizeLimit;

        return (sizeLimit = sizeLimit ? sizeLimit : this.sizeLimitDefault);
    }

    public addValidator(name: string, validator: ValidatorFn) {
        const control = this.form.get(name);

        if (control) {
            const existingValidators = control.validator;
            control.setValidators(Validators.compose([existingValidators, validator]));
            control.updateValueAndValidity();
        }
    }

    public removeValidators(name: string) {
        const control = this.form.get(name);

        if (control) {
            control.clearValidators();

            control.updateValueAndValidity();
        }
    }

    public getConfig() {
        return config;
    }

    public isFieldRequired(name: string): boolean {
        const e = this.form.get(name);
        return e?.hasValidator(Validators.required) || false;
    }

    public isFieldInvalid(name: string, error: string, submitted?: boolean) {
        const e = this.form.get(name);

        if (e && !e.touched) {
            if (submitted == undefined) {
                return this.isFieldInvalidNoSubmit(name, error) && this.submitted;
            } else {
                return this.isFieldInvalidNoSubmit(name, error) && submitted;
            }
        }

        return this.isFieldInvalidNoSubmit(name, error);
    }

    public isFieldInvalidNoSubmit(name: string, error: string) {
        const e = this.form.get(name);
        return e && (e.hasError(error) || this.hasCustomError(e, error));
    }

    public isFieldValid(name: string) {
        const e = this.form.get(name);
        if (e && e.validator) {
            return e.valid; //&& e.dirty
        }

        return false;
    }

    protected hasCustomError(e: AbstractControl, error: string) {
        if (e.errors) {
            if (e.errors.customErrors) {
                for (const item of e.errors.customErrors) {
                    if (item.key == error) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    public displayFieldCss(field: string, submitted?: boolean) {
        const e = this.form.get(field);

        let someInvalid = false;
        const allValid: boolean = this.isFieldValid(field);

        if (e) {
            if (e.errors) {
                someInvalid = Object.keys(e.errors).some(s => {
                    let invalid;

                    if (submitted == undefined) {
                        invalid = this.isFieldInvalid(field, s);
                    } else {
                        invalid = this.isFieldInvalid(field, s, submitted);
                    }

                    if (invalid) {
                        return invalid;
                    } else {
                        return false;
                    }
                });
            }
        }

        return {
            'is-invalid': someInvalid,
            'is-valid': allValid,
        };
    }

    public displayFieldCssNgSelectNoSubmit(field: string) {
        const e = this.form.get(field);

        let someInvalid = false;
        const allValid: boolean = this.isFieldValid(field);

        if (e) {
            if (e.errors) {
                someInvalid = Object.keys(e.errors).some(s => {
                    const invalid = this.isFieldInvalidNoSubmit(field, s);
                    if (invalid) {
                        return invalid;
                    } else {
                        return false;
                    }
                });
            }
        }

        return {
            'is-invalid-ng-select': someInvalid,
            'is-valid-ng-select': allValid,
        };

        //return {
        //    'ng-invalid ng-select.ng-invalid.ng-touched': someInvalid,
        //    'is-valid': allValid

        //};
    }

    public displayFieldCssNgSelect(field: string) {
        const e = this.form.get(field);

        let someInvalid = false;
        const allValid: boolean = this.isFieldValid(field);

        if (e) {
            if (e.errors) {
                someInvalid = Object.keys(e.errors).some(s => {
                    const invalid = this.isFieldInvalid(field, s);
                    if (invalid) {
                        return invalid;
                    } else {
                        return false;
                    }
                });
            }
        }

        return {
            'is-invalid-ng-select': someInvalid,
            'is-valid-ng-select': allValid,
        };

        //return {
        //    'ng-invalid ng-select.ng-invalid.ng-touched': someInvalid,
        //    'is-valid': allValid

        //};
    }

    public displayFieldCssToggleButton(field: string) {
        const e = this.form.get(field);

        let someInvalid = false;
        const allValid: boolean = this.isFieldValid(field);

        if (e) {
            if (e.errors) {
                someInvalid = Object.keys(e.errors).some(s => {
                    const invalid = this.isFieldInvalid(field, s);
                    if (invalid) {
                        return invalid;
                    } else {
                        return false;
                    }
                });
            }
        }

        return {
            '.is-invalid-toggle-buttton': someInvalid,
            'is-valid-toggle-buttton': allValid,
        };

        //return {
        //    'ng-invalid ng-select.ng-invalid.ng-touched': someInvalid,
        //    'is-valid': allValid

        //};
    }

    public displayGridHidden(list: any) {
        let hasRows = false;

        if (list) {
            hasRows = list.length;
        }

        return {
            '': hasRows,
            'ocultar-grid': !hasRows,
        };
    }

    public displayFieldCssCal(field: string) {
        const e = this.form.get(field);

        let someInvalid = false;
        const allValid: boolean = this.isFieldValid(field);

        if (e) {
            if (e.errors) {
                someInvalid = Object.keys(e.errors).some(s => {
                    const invalid = this.isFieldInvalid(field, s);
                    if (invalid) {
                        return invalid;
                    } else {
                        return false;
                    }
                });
            }
        }

        return {
            'is-invalid-cal': someInvalid,
            'is-valid': allValid,
        };
    }

    public displayFieldCssCalNoSubmit(field: string) {
        const e = this.form.get(field);

        let someInvalid = false;
        const allValid: boolean = this.isFieldValid(field);

        if (e) {
            if (e.errors) {
                someInvalid = Object.keys(e.errors).some(s => {
                    const invalid = this.isFieldInvalidNoSubmit(field, s);
                    if (invalid) {
                        return invalid;
                    } else {
                        return false;
                    }
                });
            }
        }

        return {
            'is-invalid-cal': someInvalid,
            'is-valid': allValid,
        };
    }

    public displayFieldCssNoSubmit(field: string) {
        const e = this.form.get(field);

        let someInvalid = false;
        const allValid: boolean = this.isFieldValid(field);

        if (e) {
            if (e.errors) {
                someInvalid = Object.keys(e.errors).some(s => {
                    const invalid = this.isFieldInvalidNoSubmit(field, s);
                    if (invalid) {
                        return invalid;
                    } else {
                        return false;
                    }
                });
            }
        }

        return {
            'is-invalid': someInvalid,
            'is-valid': allValid,
        };
    }

    public catchServerError(error: any) {
        if (!this.exceptionManager) {
            throw new Error('No existe ExceptionManager');
        }

        this.exceptionManager.handleError400(error, (s: string, p: string) => {
            this.setCustomError(s, p);
        });
    }

    protected setCustomError(key: string, field: string) {
        const e = this.form.get(field);

        if (e) {
            const errors = [];
            const custom = new CustomError();
            custom.key = key;
            custom.field = field;
            custom.value = true;

            errors.push(custom);

            e.setErrors({ customErrors: errors });
        }
    }

    /**
     * Elimina del array de custom errors del control, el indicado por el key.
     * @param key string
     * @param field string
     */
    public removeCustomError(key: string, field: string): void {
        const e = this.form.get(field);

        if (e && e.errors) {
            const filteredCustomErrors = (e.errors?.customErrors as Array<CustomError>).filter(err => err.key !== key);
            e.setErrors({ customErrors: filteredCustomErrors });
        }
    }

    public addErrorMessage(msg: string) {
        if (!this.notificationService) {
            throw new Error('No existe NotificationService');
        }

        this.notificationService.addErrorMessage(msg);
    }

    public addInfoMessage(msg: string) {
        if (!this.notificationService) {
            throw new Error('No existe NotificationService');
        }

        this.notificationService.addInfoMessage(msg);
    }

    public addWarningMessage(msg: string) {
        if (!this.notificationService) {
            throw new Error('No existe NotificationService');
        }

        this.notificationService.addWarningMessage(msg);
    }

    public addSuccessMessage(msg: string) {
        if (!this.notificationService) {
            throw new Error('No existe NotificationService');
        }

        this.notificationService.addSuccessMessage(msg);
    }

    public OpenDownloadedFile(res: HttpResponse<Blob>) {
        const fileURL = URL.createObjectURL(res.body!);
        const link = document.createElement('a');

        link.href = fileURL;
        link.download = res!.headers!.get('content-disposition')!.split(';')[1].split('filename')[1].split('=')[1].trim().replace(/"/g, '');

        link.click();
        this.addSuccessMessage('Archivo descargado correctamente');
    }

    // Getters para obtener el perfil del usuario que está conectado en ese momento
    get isAdmin(): boolean {
        return this.loggedInUser?.hasProfile(TcPerfilUsuarioEnum.Administrador) || false;
    }

    get isInspector(): boolean {
        return this.loggedInUser?.hasProfile(TcPerfilUsuarioEnum.Inspector) || false;
    }

    get isSolicitante(): boolean {
        return this.loggedInUser?.hasProfile(TcPerfilUsuarioEnum.Solicitante) || false;
    }

    get isConsultas(): boolean {
        return this.loggedInUser?.hasProfile(TcPerfilUsuarioEnum.Consultas) || false;
    }

    get isCoordinador(): boolean {
        return this.loggedInUser?.hasProfile(TcPerfilUsuarioEnum.Coordinador) || false;
    }

    get isGrabador(): boolean {
        return this.loggedInUser?.hasProfile(TcPerfilUsuarioEnum.Grabador) || false;
    }

    get isOperadorCam(): boolean {
        return this.loggedInUser?.hasProfile(TcPerfilUsuarioEnum.OperadorCampania) || false;
    }

    get isEA(): boolean {
        return this.loggedInUser?.hasProfile(TcPerfilUsuarioEnum.EntidadAuditora) || false;
    }

    get isCA(): boolean {
        return this.loggedInUser?.hasProfile(TcPerfilUsuarioEnum.ComunidadAutonoma) || false;
    }

    get isAC(): boolean {
        return this.loggedInUser?.hasProfile(TcPerfilUsuarioEnum.AgenteControl) || false;
    }

    // Se construye un objeto que será utilizado para la gestión de los permisos por usuario
    getUserData(): void {
        this.userData = {
            idUsuario: this.loggedInUser!.Id || 0,
            isAdmin: this.isAdmin,
            loggedInUser: this.loggedInUser!,
            idCA: this.loggedInUser?.TwUsuarioCa?.IdCa || 0,
            isOperadorCam: this.isOperadorCam,
        };
    }
}
